import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  deChatHistorySummarizerQuery as DeChatHistorySummarizerQuery,
} from "@/modules/patients/detail/progress-note/services/de/__generated__/deChatHistorySummarizerQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deChatHistorySummarizerQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    summarizeChatAppointment: de_summarizeChatAppointment(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const deChatHistorySummarizerQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<DeChatHistorySummarizerQuery>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
